import {AxiosResponse} from 'axios';
import {ActivityType} from '../backend/interfaces/activity-type';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class ActivityTypesRepository {
  // Singleton Instance
  private static _instance: ActivityTypesRepository;

  // Private
  private logger: Logger;

  static get instance(): ActivityTypesRepository {
    if (!this._instance) {
      this._instance = new ActivityTypesRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('ActivityTypesRepository');
  }

  // Get an activity type by id
  public async getById(id: string, localize: boolean): Promise<ActivityType> {
    // Set url
    let url: string = `/activity-types/${id}?localize=${localize}`;

    // Get activity type from backend
    const result: AxiosResponse<ActivityType> =
      await BackendApiManager.instance.get<ActivityType>(url);

    // Return
    return result.data;
  }
}
